import { Component, ViewChild } from '@angular/core';
import { ConstantsUtil } from 'src/app/core/utils/constants.util';

@Component({
  selector: 'app-admin-error',
  templateUrl: './admin-error.component.html',
  styleUrls: ['./admin-error.component.scss']
})
export class AdminErrorComponent {
  public headerAppName: string;
  @ViewChild('headerAppContainer') headerAppContainerRef;
  public errorMessage:string = ConstantsUtil.constants.ADMIN_ERROR.ERROR_MESSAGE;
  public errorResolutionText:string = ConstantsUtil.constants.ADMIN_ERROR.ERROR_RESOLUTION_TEXT;
}
